<script>
    import { onMount } from "svelte";
    import { fly } from "svelte/transition";
    import ProgressBar from "./components/ProgressBar.svelte";
    import BtnPict from "./components/BtnPict.svelte";
    import { ST_score, ST_gamestart } from "./stores.js";


    let appearImg = 16;
    let imageCount = 20;
    let imgArray = [];

    let isVisible = false;

    export const changeImage = () => {
        setAnimation();
        imgArray = [];
        const appearRnd = Math.ceil(Math.random() * appearImg) - 1;
        const imageRnd = Math.ceil(Math.random() * imageCount);
        for (let step = 0; step < appearImg; step++) {
            if (appearRnd == step) {
                // imgArray.push(`pict_img/${imageRnd}-A.png`);
                // ※pushの場合は変数に再代入する必要がある
                // imgArray = imgArray;
                imgArray = [...imgArray, `pict_img/${imageRnd}-A.png`];
            } else {
                // imgArray.push(`pict_img/${imageRnd}-B.png`);
                imgArray = [...imgArray, `pict_img/${imageRnd}-B.png`];
            }
        }
    };

    const clickAction = () => {
        changeImage();
        appearImg = Math.ceil(appearImg * 1.2) ;
        ST_score.update((n) => n + 1);
    };

    const setAnimation = () => {
        isVisible = false;
        setTimeout(() => (isVisible = true), 500);
    };

    onMount(() => {
        ST_gamestart.set(true);
        changeImage();
    });
</script>

{#if isVisible}
    <div transition:fly={{ y: 100 }} class="container has-text-centered">
        {#each imgArray as img}
            <BtnPict imagePath={img} clickFunc={clickAction} />
        {/each}
    </div>
{/if}

<ProgressBar />


